/*eslint-disable*/

import React from 'react';
import { layouts } from 'seal-ui-components';
import mixpanelEvents from '@Mixpanel';
import store from '@Store';
import { MIX_PANEL } from '@Constants/types';
import { Indent } from './TreeItem.style';
import { ClauseSummaryCard } from '../../ClauseSummaryCard';

const { HorizontalBox } = layouts;

export const TreeItem = props => {
    const { flattenClauseGroups, option, noIndentation } = props;
    const { clauses = [] } = option;
    const [isOpened, setIsOpened] = React.useState(false);

    const handleOnToggle = () => {
        setIsOpened(!isOpened);

        const mixpanel = {
            clausesInGroupCount: (option.clauses && option.clauses.length) || 0,
            subgroupsInGroupCount: (option.groups && option.groups.length) || 0
        };
        store.dispatch({ type: MIX_PANEL.MIXPANEL_DATA_CLAUSE_LIBRARY, payload: mixpanel });
        mixpanelEvents.clauseLibraryExpandGroup();
    };

    let parentId = flattenClauseGroups[option.id].parent_id;

    const renderChildren = childNodes => {
        return childNodes.map((child, index) => (
            <TreeItem
                key={`${option.id} ${index}`}
                option={child}
                flattenClauseGroups={flattenClauseGroups}
                clause={option}
                noIndentation={noIndentation}
            />
        ));
    };

    const hasChildren = option.children && option.children.length > 0;
    const isExpanded = hasChildren && isOpened;
    const willHideControls = !hasChildren && !clauses.length;

    return (
        <>
            <HorizontalBox>
                {!noIndentation && parentId && <Indent />}
                <ClauseSummaryCard
                    clauseId={option.id}
                    onToggle={handleOnToggle}
                    isExpanded={!!isOpened}
                    clause={option}
                    hideControls={willHideControls}
                    hasChildren={hasChildren}
                    parentId={parentId}
                />
            </HorizontalBox>
            {isExpanded && hasChildren && renderChildren(option.children)}
        </>
    );
};
